import { render, staticRenderFns } from "./SupplyApply.vue?vue&type=template&id=24b5e3e5&scoped=true"
import script from "./SupplyApply.vue?vue&type=script&lang=js"
export * from "./SupplyApply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b5e3e5",
  null
  
)

export default component.exports